import Vue from 'vue';
import Router from 'vue-router';

import Home from './components/pages/Home';
import Services from './components/pages/Services';
import Youtube from './components/pages/Youtube';
import About from './components/pages/About';
import Games from './components/pages/Games';
import NotFound from './components/pages/NotFound';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    { path: '/', name: 'Home', component: Home },
    { path: '/services', name: 'Services', component: Services },
    { path: '/youtube', name: 'Youtube', component: Youtube },
    { path: '/about', name: 'About', component: About },
    { path: '/games', name: 'Games', component: Games },
    { path: '/not-found', name: 'NotFound', component: NotFound, alias: ['/not-found'] },
    { path: '*', name: 'Default', redirect: { name: 'NotFound' } },
  ],
});
